import { FiatPrice, RewardsPrice } from "redmond";
import {
  getTotalPriceText,
  getRewardText,
  twoDecimalFormatter,
  getPriceString,
} from "halifax";

export const LOCATION_TEXT = "Tasmania, Australia";
export const CFAR_DETAILS_SUBTITLE =
  "Plan your trip worry-free. Add the flexibility to cancel your hotel booking for any reason.";
export const WARNING_BANNER_COPY =
  "If you don't add this option, your booking is nonrefundable.";

export const CAP1_HOTEL_CFAR_REFUNDABLE_UPON_CANCELLATION = (
  cfarPremium: FiatPrice,
  perNight: boolean
) =>
  `This ${getPriceString({
    price: Math.ceil(cfarPremium.value),
    priceFormatter: twoDecimalFormatter,
  })} ${
    perNight ? "per night" : ""
  } fee is <strong>included in your refund upon cancellation.</strong>`;

export const CAP1_HOTEL_CFAR_NONREFUNDABLE_UPON_CANCELLATION = (
  cfarPremium: FiatPrice,
  perNight: boolean
) =>
  `This ${getPriceString({
    price: Math.ceil(cfarPremium.value),
    priceFormatter: twoDecimalFormatter,
  })} ${
    perNight ? "per night" : ""
  } fee is <strong>nonrefundable upon cancellation.</strong>`;

export const YES_OPTION_COPY = (
  fiat: FiatPrice,
  reward: RewardsPrice | undefined
) =>
  `Yes, add this option for <strong>${getTotalPriceText({
    price: fiat,
    priceFormatter: twoDecimalFormatter,
  })}</strong>${
    reward
      ? ` / ${getRewardText({
          reward,
        })}`
      : ""
  }.`;
export const NO_OPTION_COPY = `No, thanks. I don't want to add this option.`;

export const CONTINUE_BUTTON_COPY = "Continue";

export const READ_TERMS_AND_CONDITIONS_COPY = "Read terms and conditions";
export const VIEW_TERMS_AND_CONDITIONS_COPY = "View Terms and Conditions";

export const CFAR_RADIO_BUTTONS_GROUP =
  "Cancel-for-any-reason attachment radio buttons group";

export const CFAR_NO_OPTION_SELECTED_COPY =
  "You must add or decline this option to continue.";

// note: dayjs doesn't seem to have any format that looks like this, see https://day.js.org/docs/en/display/format
export const getNthDay = (day: number) => {
  const dayString = String(day);
  const last = +dayString.slice(-2);

  if (last > 3 && last < 21) return "th";
  switch (last % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
